import { useMap } from '@vis.gl/react-google-maps';
import { useEffect, useState } from 'react';
import { useMapViewportFilterContext } from '../context/map-viewport-filter';
import { boundsToBBox } from '../utils/geojson';

export function useMapViewportFilter() {
  const map = useMap();
  const { mapViewportFilter } = useMapViewportFilterContext();
  const [bbox, setBbox] = useState(boundsToBBox(map?.getBounds()));

  useEffect(() => {
    if (mapViewportFilter.disabled) {
      return;
    }

    const listener = map?.addListener('idle', () => {
      setBbox(boundsToBBox(map?.getBounds()));
    });
    return () => {
      listener?.remove();
    };
  }, [map, mapViewportFilter.disabled]);

  return bbox;
}
